'use client';

import React, { memo } from 'react';

import {
  classNameBind,
  isEmpty,
  isString,
} from '@wconcept/wconcept-ui/utils/common';
import { sanitizeContent } from '@wconcept/wconcept-ui/utils/htmlSanitizer';

import * as S from './style';

interface IProps {
  className?: string;
  children: React.ReactNode;
  size?: string | number;
  weight?: string | number;
  lineHeight?: string | number;
  color?: string;
  align?: string; // 'left' | 'center' | 'right'
  font?: string; // 'regular' | 'light' | 'medium' | 'semibold' | 'bold'
  maxWidth?: string | number;
  block?: boolean;
  paragraph?: boolean;
  underline?: boolean;
  del?: boolean;
  strong?: boolean;
  em?: boolean;
  italic?: boolean;
  ellipsis?: number;
}

const Text = ({
  className,
  children,
  size,
  weight,
  lineHeight,
  color,
  align,
  font,
  maxWidth,
  block = false,
  paragraph = false,
  underline = false,
  del = false,
  strong = false,
  em = false,
  italic = false,
  ellipsis = 0,
}: IProps) => {
  let as = 'span';
  if (block) {
    as = 'div';
  } else if (paragraph) {
    as = 'p';
  }
  const param = {
    className: classNameBind(['text', className || '']),
    $size: size,
    $weight: weight,
    $color: color,
    $align: align,
    $font: font,
    $lineHeight: lineHeight,
    $underline: underline,
    $del: del,
    $strong: strong,
    $em: em,
    $italic: italic,
    $ellipsis: ellipsis,
    as,
    $maxWidth: maxWidth,
  };
  let childrenProp = children;

  if (!underline && del) childrenProp = <del>{children}</del>;
  if (italic) childrenProp = <i>{children}</i>;
  if (em) childrenProp = <em>{children}</em>;
  if (strong) childrenProp = <strong>{children}</strong>;

  const str = (node: React.ReactNode) => String(node);

  return (
    <>
      {!isEmpty(childrenProp) && isString(childrenProp) ? (
        <S.Text
          {...param}
          dangerouslySetInnerHTML={{
            __html: sanitizeContent(str(childrenProp)),
          }}
        />
      ) : (
        <S.Text {...param}>{childrenProp}</S.Text>
      )}
    </>
  );
};

export default memo(Text);
